import React, { useState, useMemo } from 'react';
import _sortBy from 'lodash/sortBy';
import makeStyles from '@material-ui/core/styles/makeStyles';

import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Widget } from 'pages/Homepage/typings';

interface Props {
  availableWidgets: Array<Widget>;
  onSelectWidget: (widget: Widget) => void;
}

function WidgetToLayoutSelector({ availableWidgets, onSelectWidget }: Props) {
  const classes = useStyles();
  const [filteredWidgets, setFilteredWidgets] = useState(availableWidgets);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const value = e.currentTarget.value.toLowerCase() || '';
    setFilteredWidgets(availableWidgets.filter(w => w.name.toLowerCase().includes(value)));
  };

  const filteredWidgetsSortByName = useMemo(() => _sortBy(filteredWidgets, 'name'), [
    filteredWidgets,
  ]);

  return (
    <div className={classes.root}>
      <TextField
        id="search"
        type="search"
        placeholder="Search widgets"
        onChange={handleSearch}
        className={classes.search}
      />

      <div className={classes.items}>
        {filteredWidgetsSortByName.map((item, i) => (
          <MenuItem onClick={() => onSelectWidget(item)} key={`${item.name}-${i}`}>
            {item.name}
          </MenuItem>
        ))}
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 300,
    maxHeight: 478,
    padding: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  search: {
    width: '100%',
  },
  items: {
    flex: '1 1 auto',
    overflow: 'auto',
  },
}));

export default WidgetToLayoutSelector;
